
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const Activity = () => (
      <>
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
      </>
    );
    export default Activity;
    